export default __webpack_public_path__ + "static/media/keys.a9b98ab7.png";